/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notfound_Title1Inputs */

const he_notfound_title1 = /** @type {(inputs: Notfound_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`העמוד שאליו הגעתם לא נמצא.`)
};

const en_notfound_title1 = /** @type {(inputs: Notfound_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Page not found`)
};

/**
* | output |
* | --- |
* | "Page not found" |
*
* @param {Notfound_Title1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const notfound_title1 = /** @type {((inputs?: Notfound_Title1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notfound_Title1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_notfound_title1(inputs)
	return en_notfound_title1(inputs)
});
export { notfound_title1 as "notFound_title" }